<template>
  <div class="support-ticket-modal">
    <div class="support-ticket-modal__content">
      <h2 class="support-ticket-modal__title">Обращение в поддержку</h2>
      <p class="support-ticket-modal__description">
        Опишите вашу проблему, и мы постараемся помочь.
      </p>
      <p class="support-ticket-modal__description">
          Ответ придет в Telegram боте.
      </p>
      <textarea
        v-model="message"
        class="support-ticket-modal__textarea"
        placeholder="Введите ваше сообщение..."
        rows="5"
      ></textarea>
    </div>
    
    <div class="support-ticket-modal__footer">
      <BaseButton
        class="support-ticket-modal__submit-btn"
        text="Отправить"
        styles="primary-gradient"
        vibration="success"
        :is-disabled="!message.trim()"
        @on-submit="submit"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import BaseButton from '../Base/BaseButton.vue';
import { SentryService } from '@/shared/lib/sentry/sentryService';

const emit = defineEmits(['submit']);
const props = defineProps({
  onClose: {
    type: Function,
    required: false
  }
});

const message = ref('');

// Отправляем отчет об открытии модалки
SentryService.trackModalOpen('Поддержка')

const submit = () => {
  if (message.value.trim()) {
    // Отправляем отчет о создании тикета
    SentryService.trackUserAction('Создание тикета в поддержку', {
      message_length: message.value.length,
      modal: 'support_ticket'
    })
    
    emit('submit', message.value);
    if (props.onClose) {
      props.onClose();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';
@import '@/assets/styles/mixins.scss';

.support-ticket-modal {
  display: flex;
  flex-direction: column;
  text-align: center;

  &__content {
    display: flex;
    flex-direction: column;
    padding: 10px;
    justify-content: flex-start;
  }

  &__footer {
    margin-top: 24px;
    border-top: 1px solid $secondary-200;
    padding-top: 16px;
  }

  &__title {
    @include h1;
    color: $neutral-100;
  }

  &__description {
    @include p2-regular;
    color: $neutral-40;
    &:first-of-type {
        margin-top: 16px;
    }

    &:nth-of-type(2) {
        margin-top: 10px;
    }
  }

  &__textarea {
    margin-top: 16px;
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid $neutral-100;
    // background-color: $neutral-80;
    color: $neutral-100;
    resize: none;
    font-family: inherit;
    flex: 1;
    min-height: 120px;

    &:focus {
      outline: none;
      border-color: $primary-100;
    }
  }

  &__submit-btn {
    width: 100%;
    height: 48px;
  }
}
</style>
